import createToirApp from '@infotech/toir-4sides-front-core'

import mapissuesConfig from './mapissuesConfig'
import getHeaderConfig from './headerConfig'

createToirApp({
  mapissuesModuleExtension: mapissuesConfig,
  headerConfig: getHeaderConfig(),
})
